import { Component, OnInit } from '@angular/core'
import { BreadcrumbService } from '../../shared-components/breadcrumb.service'
import { Router, ActivatedRoute } from '@angular/router'
import { DataPageOfUser, User } from '../../../../api/models'
import { UserService } from '../../../../api/services/user.service'
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api'
import { environment } from '../../../../../environments/environment'
import { CareFinitySession } from '../../../services/CareFinitySession'

@Component({
    templateUrl: './user-list.component.html',
})
export class UserListComponent implements OnInit {
    users: DataPageOfUser = {}
    selectedUser: User
    cols: any[]
    lastName: string = '';
    firstName: string = '';
    loginName: string = '';
    practiceId: string
    rows: number
    Showrecords: boolean
    confirmDropuserDialogVisible = false
    first: number = 0 // Variable to track the first record

    loginUserId: number
    constructor(
        private messageService: MessageService,
        private breadcrumbService: BreadcrumbService,
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private confirmation: ConfirmationService,
    ) {
        this.breadcrumbService.setItems([{ label: '' }])
    }

    ngOnInit() {
        this.practiceId = localStorage.getItem('PracticeId') //this.route.snapshot.paramMap.get('practice_id')

        this.loginUserId = CareFinitySession.user.userID

        this.cols = [
            { field: 'loginId', header: 'Login Name', sort: true },
            { field: 'lname', header: 'Last Name', sort: true },
            { field: 'fname', header: 'First Name', sort: true },
            { field: 'mi', header: 'MI', sort: true },

            { field: 'ehrUserName', header: 'EHR UserName', sort: true },
            { field: 'userRole', header: 'Role', sort: true },
            /*{ field: 'roles', subfield: 'roleName', header: 'Role', sort: false },*/
        ]
    }

    onAddNewUser(): void {
        this.router.navigate(
            ['administration', 'create_user', this.practiceId, '-'],
            { skipLocationChange: true },
        )
        /// this.router.navigate(['administration', 'create_user', this.practiceId, "-"]);
    }

    onDeleteUser(userid: string): void {
        console.log('on Add New User called')
        this.userService
            .userDelete({ userId: +userid, practiceId: this.practiceId })
            .subscribe((result) => {
                this.messageService.add({
                    key: 'alertToast',
                    severity: 'success',
                    summary: 'User Deleted Successfully',
                    detail: 'User Deleted Successfully',
                })

                //            setTimeout(() => {
                //                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                //                    this.router.navigate(['administration', 'user-list']);
                //                });
                //},1000)

                // this.router.navigate(['dashboard', 'user-list', this.practiceId]);

                this.first = 1;
                this.clearUserList()
            })
    }

    onEditUser(userId: number): void {
        console.log('on Edit New User called: ', userId)
        this.router.navigate(
            ['administration', 'create_user', this.practiceId, userId],
            { skipLocationChange: true },
        )
    }

    lock(user: User) {
        this.confirmation.confirm({
            key: 'delete_confirmation',
            message: 'Are you sure you want to lock this user?',
            accept: () => {
                this.userService
                    .userLock({ userID: user.userId })
                    .subscribe((result) => {
                        this.messageService.add({
                            key: 'alertToast',
                            severity: 'success',
                            detail: 'user locked successfully',
                            summary: 'Confirmation',
                            life: 7000,
                        })
                        user.isLocked = true
                    })
            },
        })
    }

    unlock(user: User) {
        this.confirmation.confirm({
            key: 'delete_confirmation',
            message: 'Are you sure you want to unlock this user?',
            accept: () => {
                this.userService
                    .userUnLock({ userID: user.userId })
                    .subscribe((result) => {
                        this.messageService.add({
                            key: 'alertToast',
                            severity: 'success',
                            detail: 'user unlocked successfully',
                            summary: 'Confirmation',
                            life: 7000,
                        })
                        user.isLocked = false
                    })
            },
        })
    }
    clearUserList(): void {
        this.lastName = '';
        this.firstName = '';
        this.loginName = '';
        this.Showrecords = true;
        this.getUserList(1, '', '');
    }
    getUserList(pageNumber: number, sortcolumn: string, sortorder: string): void {

        debugger;
        //this.first = pageNumber;
        if (sortcolumn == '' && sortorder == '') {
            sortcolumn = 'loginId'
            sortorder = 'Asc'
        }
        let serachtext = '';


        console.log(this.lastName);
        console.log(this.lastName);

        //if (this.lastName && this.lastName.trim() !== '')
        //{
        //    serachtext += "#LN#" + this.lastName.trim();
        //}

        //if (this.firstName && this.firstName.trim() !== '') {
        //    if (serachtext !== '') {
        //        serachtext += " AND ";
        //    }
        //    serachtext += "#FN#" + this.firstName.trim();
        //}


        if (this.lastName && this.lastName.trim() !== '') {
            serachtext += "#LN#" + this.lastName.trim();
        }

        if (this.firstName && this.firstName.trim() !== '') {
            if (serachtext !== '') {
                serachtext += " AND ";
            }
            serachtext += "#FN#" + this.firstName.trim();
        }

        if (this.loginName && this.loginName.trim() !== '') {
            if (serachtext !== '') {
                serachtext += " AND ";
            }
            serachtext += "#UN#" + this.loginName.trim();
        }

        this.userService
            .userSearch({
                practiceId: this.practiceId,
                pageSize: 10,
                pageNumber: pageNumber,
                searchText: serachtext,
                SortByColumn: sortcolumn,
                SortByDirection: sortorder,
            })
            .subscribe((users) => {
                this.users = users
                this.rows = this.users.pageSize
                debugger
                if (this.users.totalRecords > 0) {
                    this.Showrecords = true
                } else {
                    this.Showrecords = false
                }
            })
    }
    nextPage($event: LazyLoadEvent) {
        debugger

        console.log($event)
        let nextPage = $event.first / $event.rows + 1
        var order = 'Asc'
        if ($event.sortOrder == -1) {
            order = 'Desc'
        }
        if ($event.first == 0) {
            this.getUserList(1, $event.sortField, order)

        } else {

            this.getUserList(nextPage, $event.sortField, order)

        }
    }

    dropuser(event: Event, userid: string) {
        if (event.defaultPrevented) return
        event.preventDefault()

        this.confirmation.confirm({
            key: 'delete_confirmation',
            message: 'Are you sure you want to delete this user?',
            accept: () => {
                this.onDeleteUser(userid)
            },
        })
    }

    sort(fieldName: string, order: number) {
        console.log(fieldName)
        console.log(order)
        this.users.data.sort((row1, row2) => {
            const val1 = row1[fieldName]
            const val2 = row2[fieldName]
            if (val1 === val2) {
                return 0
            }
            let result = -1
            if (val1 > val2) {
                result = 1
            }
            if (order < 0) {
                result = -result
            }
            return result
        })
    }

    removeAutKey(user: User) {
        this.confirmation.confirm({
            key: 'delete_confirmation',
            message:
                'Are you sure you want to reset multi-factor authentication for user ' +
                user.loginId +
                '?',
            accept: () => {
                this.userService
                    .userRemove2Fa({ userID: user.userId })
                    .subscribe((result) => {
                        this.messageService.add({
                            key: 'alertToast',
                            severity: 'success',
                            detail: 'Multi-factor authentication removed  successfully.',
                            summary: 'Confirmation',
                            life: 7000,
                        })
                        this.resetPage()
                        this.getUserList(1, '', '')
                    })
            },
        })
    }

    resetPage() {
        this.first = 0 // Set the paginator to the first page
    }
}
